import { render, staticRenderFns } from "./Busy.vue?vue&type=template&id=8784a6e2"
import script from "./Busy.vue?vue&type=script&lang=js"
export * from "./Busy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Busy.vue
// module id = null
// module chunks = 